// extracted by mini-css-extract-plugin
export var hidden = "_vj-0";